import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useServices } from "../../useHook";
import Loader from "../../../../Utils/loader";

const BASE_URL = process.env.REACT_APP_BASE_URL || "";

const ServiceDetails = () => {
  const { getServiceById } = useServices();
  const [serviceData, setServiceData] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      getServiceById(id, setServiceData);
    }
  }, [id]);

  const imageUrl = (path) => {
    if (!path) return null;
    return path.startsWith("http")
      ? path
      : `${BASE_URL.replace(/\/$/, "")}${path.startsWith("/") ? "" : "/"}${path}`;
  };

  if (!serviceData) {
    return <Loader message="Loading service details..." />;
  }

  return (
    <>
      <div className="bg-gray-100 p-4 flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold mb-1">Service Details</h2>
        </div>
      </div>

      <div className="max-w-6xl mx-auto my-6 p-6 bg-white shadow-lg rounded-lg">
        <div className="mb-6">
          <h2 className="text-3xl font-bold">{serviceData.title}</h2>
          {(serviceData.custom_url || serviceData.customUrl) && (
            <p className="text-gray-600 mt-1">
              Custom URL:{" "}
              <span className="font-medium">
                {serviceData.custom_url || serviceData.customUrl}
              </span>
            </p>
          )}
          <p className="text-sm text-gray-500 mt-2">
            Created:{" "}
            {serviceData.created_at
              ? new Date(serviceData.created_at).toLocaleDateString()
              : "—"}
          </p>
          {serviceData.updated_at && (
            <p className="text-sm text-gray-500">
              Updated: {new Date(serviceData.updated_at).toLocaleDateString()}
            </p>
          )}
        </div>

        {serviceData.image && (
          <div className="mb-6">
            <p className="font-semibold text-gray-700 mb-2">Image</p>
            <img
              src={imageUrl(serviceData.image)}
              alt={serviceData.title}
              className="rounded shadow-md max-h-80 object-contain"
            />
          </div>
        )}

        {serviceData.video && (
          <div className="mb-6">
            <p className="font-semibold text-gray-700 mb-2">Video</p>
            <video
              src={imageUrl(serviceData.video)}
              controls
              className="rounded shadow-md max-w-full max-h-96"
            />
          </div>
        )}

        {serviceData.images?.length > 0 && (
          <div className="mb-6">
            <p className="font-semibold text-gray-700 mb-2">Gallery</p>
            <div className="flex flex-wrap gap-2">
              {serviceData.images.map((img, idx) => {
                const url = typeof img === "object" ? img.image_url : img;
                return (
                  <img
                    key={img.id ?? idx}
                    src={imageUrl(url)}
                    alt=""
                    className="rounded shadow-md h-32 w-32 object-cover"
                  />
                );
              })}
            </div>
          </div>
        )}

        {serviceData.description && (
          <div className="mt-6">
            <p className="font-semibold text-gray-700 mb-2">Description</p>
            <div
              className="prose max-w-none"
              dangerouslySetInnerHTML={{ __html: serviceData.description }}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default ServiceDetails;
